export function getEmbedUrl(url: string): string {
  if (!url) return "";

  // Handle YouTube
  const youTubeMatch = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/
  );
  if (youTubeMatch) {
    return `https://www.youtube.com/embed/${youTubeMatch[1]}`;
  }

  // Handle Vimeo with token in path (e.g., /video_id/token)
  const vimeoPathTokenMatch = url.match(
    /vimeo\.com\/(?:video\/)?(\d+)\/([\w\d]+)/
  );
  if (vimeoPathTokenMatch) {
    const videoId = vimeoPathTokenMatch[1];
    const token = vimeoPathTokenMatch[2];
    return `https://player.vimeo.com/video/${videoId}?h=${token}`;
  }

  // Handle Vimeo with token in query (e.g., ?h=token)
  const vimeoQueryTokenMatch = url.match(
    /vimeo\.com\/(?:video\/)?(\d+)(?:\?h=([\w\d]+))?/
  );
  if (vimeoQueryTokenMatch) {
    const videoId = vimeoQueryTokenMatch[1];
    const token = vimeoQueryTokenMatch[2];
    return token
      ? `https://player.vimeo.com/video/${videoId}?h=${token}`
      : `https://player.vimeo.com/video/${videoId}`;
  }

  return "";
}
